export class LabComponentDetail {       
    labComponentHeaderId: number;
    labComponentDetailId: number;
    parameterName: string;
    displayName: string;
    labParameterHeaderId: number;
    priority: number;
}